interface ResolveCoupangCtaBlockedLabelParams {
  isChecking: boolean;
  isWelloApp: boolean;
  isResolving: boolean;
  advertisingId: string | null;
  productCount: number;
}

//* 웹은 앱 게이트가 설치 모달로 안내하므로 막지 않고, 앱에서만 광고ID·추천 링크 확보 여부로 막는다.
export const resolveCoupangCtaBlockedLabel = ({
  isChecking,
  isWelloApp,
  isResolving,
  advertisingId,
  productCount,
}: ResolveCoupangCtaBlockedLabelParams) => {
  if (isChecking || (isWelloApp && isResolving)) {
    return '쿠팡에서 웰포인트 받기';
  }

  if (!isWelloApp) {
    return null;
  }

  if (!advertisingId) {
    return '광고 추적을 허용하면 참여할 수 있어요';
  }

  if (productCount === 0) {
    return '지금은 참여할 수 없어요';
  }

  return null;
};
